export const mainLogo = {
    src: "/domber.png",
    alt: `${import.meta.env.VITE_PROJECT_NAME} Logo`
}

export const projectName = import.meta.env.VITE_PROJECT_NAME || "Domber"